/**
 * 字符串工具函数
 */

/**
 * 首字母大写
 * @param str 输入字符串
 * @returns 首字母大写的字符串
 */
export function capitalize(str: string): string {
  if (!str) return str
  return str.charAt(0).toUpperCase() + str.slice(1).toLowerCase()
}

/**
 * 驼峰命名转换
 * @param str 输入字符串
 * @returns 驼峰命名格式的字符串
 */
export function toCamelCase(str: string): string {
  return str
    .replace(/(?:^\w|[A-Z]|\b\w)/g, (word, index) => {
      return index === 0 ? word.toLowerCase() : word.toUpperCase()
    })
    .replace(/\s+/g, "")
}

/**
 * 短横线命名转换
 * @param str 输入字符串
 * @returns 短横线命名格式的字符串
 */
export function toKebabCase(str: string): string {
  return str
    .replace(/([a-z])([A-Z])/g, "$1-$2")
    .replace(/[\s_]+/g, "-")
    .toLowerCase()
}

/**
 * 截断字符串
 * @param str 输入字符串
 * @param length 最大长度
 * @param suffix 后缀，默认为 '...'
 * @returns 截断后的字符串
 */
export function truncate(str: string, length: number, suffix: string = "..."): string {
  if (str.length <= length) return str
  return str.substring(0, length - suffix.length) + suffix
}

/**
 * 生成随机字符串
 * @param length 字符串长度
 * @param chars 字符集，默认为字母数字
 * @returns 随机字符串
 */
export function generateRandomString(
  length: number,
  chars: string = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789"
): string {
  let result = ""
  for (let i = 0; i < length; i++) {
    result += chars.charAt(Math.floor(Math.random() * chars.length))
  }
  return result
}
